<template>
    <b-overlay :show="formLoader">
        <b-container fluid>
            <b-row>
                <b-col lg="12" sm="12">
                    <template>
                        <b-row>
                            <b-col xs="12" sm="12" md="12" class="text-right mb-2">

                              <a  v-if="formData.attachment && id" class="btn btn-primary mr-2" :href="trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/questions/'+formData.attachment">{{$t('tp_management.d_attachment')}}</a>
                              <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                            </b-col>
                            <b-col md="12" >
                              <table class="table table-sm table-borderless">
                                <tr>
                                  <th>{{$t('globalTrans.fiscal_year')}}</th>
                                  <td>: {{getFiscalYear(formData.fiscal_year_id)}}</td>
                                </tr>
                                <tr>
                                  <th>{{$t('tp_management.circular_no')}}</th>
                                  <td>: {{getCircularName(formData.circular_id)}}</td>
                                </tr>
                                <tr>
                                  <th>{{$t('tp_management.training') + ' ' + $t('globalTrans.name')}}</th>
                                  <td>: {{getTrainingName(formData.training_name_id)}}</td>
                                </tr>
                                <tr>
                                  <th>{{$t('trainer_trainee.batch')}}:</th>
                                  <td>: {{getBatchName(formData.batch_id)}}</td>
                                </tr>
                              </table>
                              <hr>
                            </b-col>
                            <b-col lg="12" sm="12">
                                <b-row class="mb-3">
                                    <b-col lg="6" sm="6">
                                        <div class="text-dark text-left">
                                            <span>{{ $i18n.locale === 'en' ? 'Time: ' :'সময়:' }} {{ EngBangNum(tConvert(formData.start_time)) + ' - ' + EngBangNum(tConvert(formData.end_time)) }}</span>
                                        </div>
                                    </b-col>
                                    <b-col lg="6" sm="6">
                                        <div class="text-dark text-right">
                                            <span>{{ $i18n.locale === 'en' ? 'Total Marks- ' :'পূর্ণমান- ' }} {{ $n(formData.total_marks, { useGrouping: false })  }}</span>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row style="padding-left:10px">
                                    <b-col lg="12" sm="12" class="ml-3">
                                        <b-row>
                                            <div class="text-dark text-left">
                                                <span>{{ $i18n.locale === 'en' ? '1. If true, give tick mark on T, if false, give tick mark on F.':'১. সত্য হলে স মিথ্যা হলে মি এর উপর টিক চিহ্ন দিন।' }}</span>
                                            </div>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row style="padding-left:10px" v-for="(detail, index) in formData.details.filter(item => item.q_type === 1)" :key="index">
                                        <b-col class="ml-5" md="12" >
                                            <b-row>
                                                <b-col md="10" class="text-dark text-left pl-0">
                                                    <span>{{ $n(index+1, { useGrouping: false }) }}. {{ detail.question }} {{ $i18n.locale === 'bn' ? '   স/মি':' T/F' }}</span>
                                                </b-col>
                                                <b-col md="2" class="text-dark text-center">
                                                    <span> {{ $n(detail.marks, { useGrouping: false }) }}</span>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                </b-row>
                                <b-row style="padding-left:10px" v-for="(detail, index) in formData.details.filter(item => item.q_type !== 1)" :key="index">
                                    <b-col md="12" class="mr-3">
                                        <b-row>
                                            <b-col md="10" class="text-dark text-left">
                                                <span>{{index+2}}. {{ detail.question }}</span>
                                                <div v-if="detail.q_type === 2">
                                                    <b-row class="ml-3" v-for="(item, index2) in detail.multiple_option" :key="index2">
                                                        <b-col>
                                                            {{ (index2+1) +')  ' }}{{item.option}}
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                                <div v-else class="">
                                                    <span class="ml-4">Ans:</span>
                                                    <br><br><br><br>
                                                </div>
                                            </b-col>
                                            <b-col md="2" class="text-dark text-center">
                                                <span> {{ detail.marks }}</span>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col lg="12" sm="12">
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
        </b-container>
    </b-overlay>
</template>

<script>
import { core } from '@/config/pluginInit'
import { trainingElearningServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-pdf'
export default {
    name: 'Details',
    props: ['id'],
    data () {
        return {
           trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
            formLoader: false,
            formData: {}
        }
    },
    created () {
        if (this.id) {
            const tmp = this.getData()
            this.formData.fiscal_year_id = tmp.fiscal_year_id
            this.formData.circular_id = tmp.circular_id
            this.formData.training_name_id = tmp.training_name_id
            this.formData.batch_id = tmp.batch_id
            this.formData.exam_type = tmp.exam_type
            this.formData.total_marks = tmp.total_marks
            this.formData.start_time = tmp.start_time
            this.formData.end_time = tmp.end_time
            this.formData.attachment = tmp.attachment
            this.formData.details = tmp.details
            tmp.details.forEach((item, index) => {
                this.formData.details[index].multiple_option = JSON.parse(item.multiple_option)
            })
        }
    },
    computed: {},
    mounted () {
        core.index()
    },
    methods: {
        EngBangNum (n) {
            if (this.$i18n.locale === 'bn') {
                return n.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
            } else {
                return n.replace(/[০-৯]/g, d => '০১২৩৪৫৬৭৮৯'.indexOf(d))
            }
        },
        tConvert (time) {
            // Check correct time format and split into components
            time = time
                .toString()
                .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
            if (time.length > 1) {
                time = time.slice(1)
                if (this.$i18n.locale === 'en') {
                    time[5] = +time[0] < 12 ? ' ' + 'am' : ' ' + 'pm'
                } else {
                    time[5] = +time[0] < 12 ? ' ' : ' '
                }

                time[0] = +time[0] % 12 || 12
            }
            return time.join('')
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getCircularName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getFiscalYear (id) {
            const obj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getTrainingName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        getBatchName (id) {
            const obj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text
            }
        },
        pdfExport () {
            const reportTitle = this.$t('tp_management.training_questionnaire')
            ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4, reportTitle, this.formData, this)
        }
    }
}
</script>
